import React, { createContext, useState } from "react";

// Create context for Corporate admin
export const CorporateAdminContextApi = createContext();

const CorporateAdminContext = ({ children }) => {
  // Corporate admin global state
  const [cAdminData, setCAdminData] = useState({});
  const [offset, setOffset] = useState(0);
  const [allOffset, setAllOffset] = useState([0]);
  const [cAdminCount, setCAdminCount] = useState(0);
  const [newCAdminCount, setNewCAdminCount] = useState(0);
  const [deletedCAdminCount, setDeletedCAdminCount] = useState(0);
  const [cAdminClientId, setCAdminClientId] = useState(0);

  // Set Corporate admin data into Corporate admin State(cAdminData)
  const updateCAdminState = (newData, page) => {
    setCAdminData({ ...cAdminData, [page]: newData });
  };

  const setAllOffsetState = (newOffset) => {
    setAllOffset((prevState) => [...prevState, newOffset]);
  };

  // Set offset into offSet State(offset)
  const updateCAdminOffset = (newOffset) => {
    setOffset(newOffset);
  };

  // Set corporate admin list count into corporate admin State(cAdminCount)
  const updateCAdminCount = (data) => {
    setCAdminCount(data);
  };

  // Edit corporate admin and update corporate admin list
  const editCAdminList = () => {
    setCAdminData({});
    setAllOffset([0]);
  };

  // Set current corporate admin data after delete functionality
  const deleteCAdminData = (newcAdminData) => {
    setCAdminData({});
    setAllOffset([0]);
  };

  // Edit corporate admin and update corporate admin list
  const addNewCAdmin = (newcAdminData) => {
    setCAdminData({});
    setAllOffset([0]);
  };

  return (
    <CorporateAdminContextApi.Provider
      value={{
        cAdminData,
        offset,
        cAdminCount,
        newCAdminCount,
        deletedCAdminCount,
        allOffset,
        cAdminClientId,
        updateCAdminState,
        updateCAdminOffset,
        deleteCAdminData,
        editCAdminList,
        addNewCAdmin,
        updateCAdminCount,
        setNewCAdminCount,
        setDeletedCAdminCount,
        setAllOffsetState,
        setCAdminClientId
      }}
    >
      {children}
    </CorporateAdminContextApi.Provider>
  );
};

export default CorporateAdminContext;
